import React from "react";
import "./RoasterSelector.css";

const RoasterSelector = ({
  roasterName,
  onRoasterChange,
  suggestions = [],
}) => {
  const datalistId = `roaster-suggestions-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="roaster-selector">
      <input
        type="text"
        value={roasterName || ""}
        onChange={(e) => onRoasterChange(e.target.value)}
        placeholder="Roaster name (optional)"
        className="roaster-input"
        maxLength={255}
        list={datalistId}
      />
      <datalist id={datalistId}>
        {suggestions.map((roaster) => (
          <option key={roaster.id} value={roaster.name} />
        ))}
      </datalist>
    </div>
  );
};

export default RoasterSelector;
